import { color, media, px2vw,radius, spacing } from '@gyym/ui'
import styled, { css } from 'styled-components'

export const FirstViewContainer = styled.div`
  position: relative;
`

export const TopImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: ${px2vw(962 / (680 / 480), 480)};

  ${media.tablet} {
    height: ${px2vw(864 / (1920 / 1024), 'pc')};
  }
`

export const TopButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: ${spacing(6)};

  ${media.tablet} {
    margin-top: ${spacing(10)};
  }
`

export const PassContainer = styled.div`
  width: 100%;
  max-width: 780px;
  padding: ${spacing(0, 6)};
  margin: ${spacing(-3)} 0 0;

  ${media.tablet} {
    margin: ${spacing(-20)} auto 0;
  }
`

export const Pass = styled.div`
  padding: ${spacing(4, 5)};
  border-radius: ${radius('xs')};
  border: 1px solid ${color('blue.01')};
  background-color: ${color('white')};
  opacity: 0.9;
  width: 100%;
  max-width: 100%;

  ${media.tablet} {
    max-width: 366px;
  }
`

export const NotificationContainer = styled.div<{ isLoggedIn: boolean }>`
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${spacing(5)};
  margin: ${spacing(0, 4)};

  ${media.pc} {
    ${({ isLoggedIn }) =>
      !isLoggedIn
        ? css`
            margin: 0 auto;
            max-width: 960px;
            bottom: ${spacing(8)};
          `
        : css`
            bottom: ${spacing(4)};
            margin: 0;
            left: calc(50% + ${spacing(12)});
          `}
  }
`
